import 'reflect-metadata';
import {jsonObject, jsonMember} from 'typedjson';

@jsonObject
export class IpAddress {

  @jsonMember({name: 'address'})
  public Address!: string;

  @jsonMember({name: 'prefixLength'})
  public PrefixLength!: number;

  public ToString(): string {
    return `${this.Address} /${this.PrefixLength}`;
  }

  public copy(): IpAddress {
    const copy = new IpAddress();
    copy.Address = this.Address;
    copy.PrefixLength = this.PrefixLength;
    return copy;
  }
}
